var _line, _line2, _line3, _line4, _line5, _line6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 22,
    viewBox: "0 0 28 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 26.0905,
    y1: 1.60135,
    x2: 15.9715,
    y2: 12.3156,
    stroke: "black",
    strokeWidth: 3
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    y1: -1.5,
    x2: 14.7374,
    y2: -1.5,
    transform: "matrix(-0.686624 -0.727013 -0.727013 0.686624 25 22)",
    stroke: "black",
    strokeWidth: 3
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 18.9477,
    y1: 1.60135,
    x2: 8.82862,
    y2: 12.3156,
    stroke: "black",
    strokeWidth: 3
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    y1: -1.5,
    x2: 14.7374,
    y2: -1.5,
    transform: "matrix(-0.686624 -0.727013 -0.727013 0.686624 17.8571 22)",
    stroke: "black",
    strokeWidth: 3
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 11.2096,
    y1: 1.60135,
    x2: 1.09052,
    y2: 12.3156,
    stroke: "black",
    strokeWidth: 3
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    y1: -1.5,
    x2: 14.7374,
    y2: -1.5,
    transform: "matrix(-0.686624 -0.727013 -0.727013 0.686624 10.119 22)",
    stroke: "black",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloser);
export default __webpack_public_path__ + "static/media/closer.a71118701280dbc2d55a5fb05ea98b50.svg";
export { ForwardRef as ReactComponent };